module.exports = __webpack_public_path__ + "img/invoiceTip2.773f11ad.png";